module.exports = __webpack_public_path__ + "static/icons/icon-user--red-c3f5f1dc3cc7f52c605c63f67d7fec19.svg";